module.exports = __webpack_public_path__ + "img/malte_it_cover.fc349209.jpg";